<script lang="ts">
	export let value: string = '';
	export let inputType: 'text' | 'email' | 'password' | 'search' | 'number' = 'text';
	export let placeholder: string = '';
	export let variant: 'default' | 'search' = 'default';
	export let size: 'sm' | 'md' | 'lg' = 'md';
	export let required: boolean = false;
	export let minlength: number | undefined = undefined;
	export let maxlength: number | undefined = undefined;
	export let step: string | undefined = undefined; // For number inputs
	export let id: string | undefined = undefined;
	export let name: string | undefined = undefined;
	export let className: string = ''; // Allow custom classes to be passed

	// Event handlers
	export let onInput: Function | undefined = undefined;
	export let onChange: Function | undefined = undefined;

	// Convert inputType to static type attribute
	$: type = inputType;
</script>

{#if type === 'text'}
	<input
		type="text"
		bind:value
		{placeholder}
		{required}
		{minlength}
		{maxlength}
		{id}
		{name}
		on:input={onInput}
		on:change={onChange}
		class="input {variant} {size} {className}"
	/>
{:else if type === 'email'}
	<input
		type="email"
		bind:value
		{placeholder}
		{required}
		{minlength}
		{maxlength}
		{id}
		{name}
		on:input={onInput}
		on:change={onChange}
		class="input {variant} {size} {className}"
	/>
{:else if type === 'password'}
	<input
		type="password"
		bind:value
		{placeholder}
		{required}
		{minlength}
		{maxlength}
		{id}
		{name}
		on:input={onInput}
		on:change={onChange}
		class="input {variant} {size} {className}"
	/>
{:else if type === 'search'}
	<input
		type="search"
		bind:value
		{placeholder}
		{required}
		{minlength}
		{maxlength}
		{id}
		{name}
		on:input={onInput}
		on:change={onChange}
		class="input {variant} {size} {className}"
	/>
{:else if type === 'number'}
	<input
		type="number"
		bind:value
		{placeholder}
		{required}
		{minlength}
		{maxlength}
		{step}
		{id}
		{name}
		on:input={onInput}
		on:change={onChange}
		class="input {variant} {size} {className}"
	/>
{/if}

<style>
	.input {
		background-color: rgba(27, 13, 42); /* #1B0D2A with 48% opacity */
		border: none;
		border-radius: 0.25rem;
		color: #f3f4f6; /* text-gray-100 */
		font-weight: 300; /* font-light */
		width: 100%;
	}

	.input:focus {
		background-color: rgba(27, 13, 42); /* #1B0D2A with 48% opacity */
		outline: none;
		box-shadow: 0 0 0 1px #59127b;
	}

	.input.default {
		border: 1px solid #59127b;
	}

	.input.sm {
		font-size: 0.875rem; /* text-sm */
		padding: 0.25rem 0.5rem; /* py-1 px-2 */
	}

	.input.md {
		font-size: 1rem; /* text-base */
		padding: 0.5rem 0.75rem; /* py-2 px-3 */
	}

	.input.lg {
		font-size: 1.5rem; /* text-lg */
		padding: 0.75rem 1rem; /* py-3 px-4 */
		font-weight: 900; /* font-black */
	}

	/* Placeholder styles */
	.input::placeholder {
		color: #9ca3af; /* text-gray-400 */
	}

	/* Disabled styles */
	.input:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
</style>
